var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-child"},[(_vm.event.questionnaire && _vm.event.questionnaire.length > 0)?_c('Questionnaire',{attrs:{"id":_vm.event.questionnaire[0]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }